module.exports = __webpack_public_path__ + "media/file-sounds-1103-quite-impressed.c8e4cd20.mp3";